import Container from '~/components/container/Container';
import NoContent from '~/components/noContent/NoConTent';

function AlbumKpop() {
    return (
        <Container>
            <NoContent />
        </Container>
    );
}

export default AlbumKpop;
